export const PINNED_LAYER_SUFFIX: string = '-pinned-layer'
export const RESPONSIVE_PAGE_CONTAINER_PREFIX: string = 'Container'
export const SECTIONS_CONTAINER_PREFIX: string = 'PAGE_SECTIONS'
export const MASTER_PAGE_COMPONENTS_IN_RESPONSIVE = [
	'masterPage',
	'SITE_PAGES',
	'SITE_HEADER',
	'SITE_FOOTER',
	'PAGES_CONTAINER',
]
export const SITE_CONTAINER_WITHOUT_HEADER_SELECTOR = '#masterPage.landingPage'
export const SITE_CONTAINER_WITH_HEADER_SELECTOR = '#masterPage:not(.landingPage)'
export const WIX_INTERACT_ELEMENT_SELECTOR = 'wix-interact-element'
